import { BottomSheet } from 'react-spring-bottom-sheet';
import lightClose from '@/assets/icons/light-close.svg'
import darkClose from '@/assets/icons/dark-close.svg'
import useBottomSheetStore from '@/store/bottom-sheet-store';
import useHomeStore from '@/store/home';
const XBottomSheet = () => {
  const { showBottomSheet, setShowBottomSheet, bgLighter, Body, onDemandClose } = useBottomSheetStore();
  const {setIsActiveRequest, isActiveRequest} = useHomeStore();
  // useEffect(() => {
  //   if(window.matchMedia('(prefers-color-scheme: dark)')?.matches && bgLighter){
  //     document.documentElement.style.setProperty('--rsbs-bg', '#34383B')
  //   } else if(window.matchMedia('(prefers-color-scheme: dark)')?.matches){
  //     document.documentElement.style.setProperty('--rsbs-bg', '#292d30')
  //   } else if(bgLighter) {
  //     document.documentElement.style.setProperty('--rsbs-bg', '#f2f2f2');
  //   } else {
  //     document.documentElement.style.setProperty('--rsbs-bg', '#ffffff');
  //   }
  // }, [bgLighter,window.matchMedia('(prefers-color-scheme: dark)')]);
  const handleCancelConfirm = () => {
    if(!isActiveRequest){
      setShowBottomSheet(false);
      setIsActiveRequest(false);
    }
  };
  const handleOndismiss = () => {
    onDemandClose && setShowBottomSheet(false)
  }
  return (
    <BottomSheet
      open={showBottomSheet}
      onDismiss={handleOndismiss}
      // blocking={false}
      snapPoints={({ minHeight }) => [minHeight]}
      header
    >
        <img src={lightClose} className='dark:hidden absolute top-0 left-4 cursor-pointer z-50' alt='close bottom sheet' onClick={handleCancelConfirm}/>
        <img src={darkClose} className='hidden dark:block absolute top-0 left-4 cursor-pointer z-50' alt='close bottom sheet' onClick={handleCancelConfirm}/>
      <Body />
    </BottomSheet>
  )
}
export default XBottomSheet